import React from "react";
import {useTheme} from "connectui/theme/ThemeProvider";
import {buildStyles} from "connectui/component/buildStyles";
import RoundIcon from "connectui/component/display/RoundIcon";
import Text from "connectui/component/display/Text";
import FlexContainer from "connectui/component/layout/FlexContainer";

const useStyles = (theme) =>
  buildStyles({
    container: {
      width: "96px",
      height: "96px",
      borderRadius: `${theme.radius.sm}px`,
      overflow: "hidden",
      backgroundColor: theme.colors.white + " !important",
      border: `1px solid ${theme.colors.border}`,
      textDecoration: "none !important",
      cursor: "pointer",
    },
  });

const MessageFile = ({attachment, showMore, onMobileClick, setShowMore}) => {
  const {theme, isMobile} = useTheme();
  const classes = useStyles(theme);

  const handleClick = () => {
    if (showMore) {
      setShowMore(true);
    } else if (isMobile) {
      onMobileClick(attachment.link);
    }
  };

  const renderContent = () => {
    if (showMore) {
      return (
        <Text weight="medium" color="white">
          +{showMore}
        </Text>
      );
    }

    if (attachment.isImage) {
      return (
        <img
          loading="lazy"
          src={attachment.link}
          alt="Attachment"
          style={{width: "100%", height: "100%", objectFit: "cover"}}
        />
      );
    }

    return (
      <RoundIcon
        iconComponent="file"
        baseColor="primary"
        sx={{
          margin: 0,
          width: "72px",
          height: "72px",
          padding: theme.spacing(3),
        }}
      />
    );
  };

  return (
    <FlexContainer
      as={showMore ? "div" : "a"}
      href={isMobile ? "#" : attachment.link}
      target="_blank"
      rel="noopener"
      download
      alignItems="center"
      justifyContent="center"
      className={classes.container}
      sx={{
        background: showMore
          ? `linear-gradient(0deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 100%), url("${attachment.link}") lightgray 50% / cover no-repeat`
          : theme.colors.white,
      }}
      onClick={handleClick}
    >
      {renderContent()}
    </FlexContainer>
  );
};

export default MessageFile;
